import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputNumberModule } from 'primeng/inputnumber';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { AccessRole, CustomTitle, FormGroupErrorMessageComponent, FormNoData, LocalService, Utils } from 'lib-base';
import { MultiSelectModule } from 'primeng/multiselect';
import { ActividadAutomaticaComponent } from './actividad-automatica.component';
import { ConfigInsercionTablaDinamicaComponent } from './config-insercion-tabla-dinamica.component';
import { CorreoPlantillaDto, IConfiguracionLLaves, IGetTipoTramiteActividadTipos, ITipoTramite, ITipoTramiteActividad, TipoTramiteActividaDto, VariablesRespuestaDinamicaParams, VwActividad } from '../../../../shared/interfaces/database/configuracion';
import { firstValueFrom, forkJoin } from 'rxjs';
import { MessageService } from 'primeng/api';
import { HttpErrorResponse } from '@angular/common/http';
import { ActividadService } from '../../../../services/database/actividad.service';
import { TipoTramiteActividadTiposService } from '../../../../services/database/tipo-tramite-actividad-tipos.service';
import { TipoTramiteService } from '../../../../services/database/tipoTramite.service';
import { ActividadGeneralComponent } from './actividad-general.component';
import { PanelModule } from 'primeng/panel';
import { CorreoTemplateService } from '../../../../services/database/correo-template.service';
import { ConfiguracionLlavesComponent, LlavesOptions } from '../../../../components/custom-work/other/configuracion-llaves/configuracion-llaves.component';
import { TipoTramiteActividaService } from '../../../../services/database/tipoTramiteActivida.service';
import { ConfigActualizacionTablaDinamicaComponent } from './config-actualizacion-tabla-dinamica.component';
import { TabViewModule } from 'primeng/tabview';

@Component({
  selector: 'app-actividad-base',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule,
    TranslateModule, PanelModule, TableModule,
    ButtonModule, DialogModule, DropdownModule, TabViewModule,
    InputNumberModule, CheckboxModule, ConfirmPopupModule,
    FormGroupErrorMessageComponent, CustomTitle, MultiSelectModule,
    ActividadAutomaticaComponent, ActividadGeneralComponent, ConfiguracionLlavesComponent,
    ConfigInsercionTablaDinamicaComponent, ConfigActualizacionTablaDinamicaComponent
  ],
  template: `
<section>
	<form [formGroup]="form" (ngSubmit)="onSubmit()">
		<p-dialog [header]="formTitle" [(visible)]="displayActividadModal" [modal]="true" [autoZIndex]="true"
			[draggable]="false" [resizable]="true" [maximizable]="true"
			[breakpoints]="{'1024px': '75vw', '640px': '100vw'}" [style]="{width: '80vw'}">

			<ng-template pTemplate="header">
				<CustomTitle [title]="formTitle" />
			</ng-template>

			<ng-template pTemplate="content">
				<main class="grid formgrid p-fluid">
					<div class="field col-12 md:col-6">
						<label for="actividadId" class="ml-3">{{'fields.tipo-tramite-actividad.actividad' | translate}}<span style="color: red">*</span></label>
						<div class="flex gap-1 justify-content-start">
							<p-dropdown [options]="actividades" formControlName="actividadId" appendTo="body"
								placeholder="Select" optionLabel="actividadCodificacion" optionValue="actividadId"
								autoWidth="false" class="flex-grow-1">
							</p-dropdown>
							<button pButton type="button" (click)="getActividades()" icon="pi pi-refresh"
								class="p-button-success"></button>
							<button pButton type="button" (click)="openLink()" icon="pi pi-plus"
								class="p-button-help"></button>
						</div>
						<ng-container
							*ngIf="form.get('actividadId')?.invalid && form.get('actividadId')?.dirty">
							<app-form-group-error-message
								[control]="form.get('actividadId')"></app-form-group-error-message>
						</ng-container>
					</div>
					<div class="field col-12 md:col-6">
						<label for="tipoId" class="ml-3">{{'common.tipo' | translate}}<span style="color: red">*</span></label>
						<div class="flex gap-1 justify-content-start">
							<p-dropdown [options]="tipoTramiteActividadTipos" formControlName="tipoId" appendTo="body"
								placeholder="Select" optionLabel="descripcion" optionValue="id"
								autoWidth="false" class="flex-grow-1">
							</p-dropdown>
						</div>
						<ng-container
							*ngIf="form.get('tipoId')?.invalid && form.get('tipoId')?.dirty">
							<app-form-group-error-message
								[control]="form.get('tipoId')"></app-form-group-error-message>
						</ng-container>
					</div>
					<div class="field col-12 md:col-6">
						<label for="orden" class="ml-3">{{'fields.tipo-tramite-actividad.orden' | translate}}<span
								style="color: red">*</span></label>
						<p-inputNumber inputId="integeronly" formControlName="orden" inputStyleClass="w-full"
							styleClass="w-full" class="w-full">
						</p-inputNumber>
						<ng-container
							*ngIf="form.get('orden')?.invalid && form.get('orden')?.touched">
							<app-form-group-error-message
								[control]="form.get('orden')"></app-form-group-error-message>
						</ng-container>
					</div>
					<div class="field col-12 md:col-6">
						<label for="plazoFechaCierre" class="ml-3">
              {{'fields.tipo-tramite-actividad.plazo-fecha-cierre'| translate}}<span style="color: red">*</span>
            </label>
						<p-inputNumber inputId="integeronly" formControlName="plazoFechaCierre" inputStyleClass="w-full"
							styleClass="w-full" class="w-full">
						</p-inputNumber>
						<ng-container
							*ngIf="form.get('plazoFechaCierre')?.invalid && form.get('plazoFechaCierre')?.touched">
							<app-form-group-error-message
								[control]="form.get('plazoFechaCierre')"></app-form-group-error-message>
						</ng-container>
					</div>

          <app-actividad-automatica
            *ngIf="tipo === 'AUTOMATICO'"
            [tipoTramite]="tipoTramite"
            [parentForm]="form"
            [editActividad]="editActividad"
            class="w-full">
          </app-actividad-automatica>

          <app-actividad-general
            *ngIf="tipo === 'GENERAL'"
            [tipoTramite]="tipoTramite"
            [parentForm]="form"
            [editActividad]="editActividad"
            class="w-full"
            (onFormSelected)="onActividadGeneralFormularioSelected($event)">
          </app-actividad-general>

          
          <p-tabView class="w-full pt-1">
              <p-tabPanel [header]="'msg.configuracionInsercionFormularioTablaDinamica' | translate" >
                <app-config-insercion-tabla-dinamica [tipoTramite]="tipoTramite">
                </app-config-insercion-tabla-dinamica>
              </p-tabPanel>
              <p-tabPanel [header]="'msg.configuracionActualizacionFormularioTablaDinamica' | translate" >
                <app-config-actualizacion-tabla-dinamica [tipoTramite]="tipoTramite">
                </app-config-actualizacion-tabla-dinamica>
              </p-tabPanel>
          </p-tabView>

          <p-panel [header]="'msg.configuraciónRespuestaDinámica' | translate" [toggleable]="true" class="w-full pt-1" [collapsed]="true">
            <div class="grid formgrid p-fluid">
              <div class="field col-12 md:col-12">
                <label for="tipoId" class="ml-3">{{'components.app-correo-plantilla.title-table' | translate}}</label>
                <div class="flex gap-1 justify-content-start">
                  <p-dropdown [options]="correosTemplate" formControlName="correoPlantillaId" appendTo="body"
                    optionLabel="nombre" optionValue="id" [placeholder]="'common.seleccionar'| translate"
                    autoWidth="false" class="flex-grow-1" [filter]="true" [showClear]="true"
                    (onClear)="oncorreoPlantillaIdClear($event)">
                  </p-dropdown>
                </div>
                <small *ngIf="variablesRespDinamicaVersionNotLatest" class="p-error block">
                  {{'common.noUltimaVersion' | translate}}
                </small>
              </div>
              <div class="field col-12 md:col-12">
                <app-configuracion-llaves #CorreoPlantillaIdLlaves [showDelete]="false" [showAdd]="false"></app-configuracion-llaves>
              </div>
            </div>
          </p-panel>
				</main>
			</ng-template>

			<ng-template pTemplate="footer">
				<div class="field col-12">
					<div class="flex justify-content-between">
						<button pButton type="button" [label]="'form.button.limpiar' | translate" iconPos="right"
							icon="pi pi-eraser" class="tax-app-button" (click)="resetForm()"></button>
						<button pButton type="submit" [label]="'form.button.guardar' | translate" icon="pi pi-save"
							iconPos="right" class="tax-app-button" [disabled]="!ls.hasRole(role.ADMIN_TRAM)"></button>
					</div>
				</div>
			</ng-template>
		</p-dialog>
	</form>
</section>

  `
})
export class ActividadBaseComponent implements OnInit, AfterViewInit {

  @Input() tipoTramite !: ITipoTramite
  @Output() onSubmitEvent = new EventEmitter<void>();
  data !: ITipoTramiteActividad[];
  form !: FormGroup;
  formTitle: string = "Nuevo";
  tipo !: string;
  editActividad !: ITipoTramiteActividad | undefined;
  tipoTramiteActividadTipos !: IGetTipoTramiteActividadTipos[]
  trans: any = {};
  actividades !: VwActividad[];
  displayActividadModal: boolean = false;
  private originalValues: any;

  role = AccessRole;
  editModalLoaded: boolean = false;
  //Respuesta Dinamica
  variablesRespDinamica!: IConfiguracionLLaves[];
  variablesRespDinamicaLoaded: boolean = false;
  variablesRespDinamicaVersionNotLatest: boolean = false;
  correosTemplate!: CorreoPlantillaDto[];

  get isNewForm(): boolean {
    return this.editActividad === undefined;
  }

  @ViewChild(ActividadAutomaticaComponent) actividadAutomaticaComponent !: ActividadAutomaticaComponent;
  @ViewChild(ActividadGeneralComponent) actividadGeneralComponent !: ActividadGeneralComponent;
  @ViewChild('CorreoPlantillaIdLlaves') correoPlantillaIdLlaves !: ConfiguracionLlavesComponent;
  @ViewChild(ConfigInsercionTablaDinamicaComponent) configInsercionTablaDinamicaComponent !: ConfigInsercionTablaDinamicaComponent;
  @ViewChild(ConfigActualizacionTablaDinamicaComponent) configActualizacionTablaDinamicaComponent !: ConfigActualizacionTablaDinamicaComponent;


  constructor(private readonly _fb: FormBuilder, private readonly _t: TranslateService,
    private readonly _ac: ActividadService, private ttats: TipoTramiteActividadTiposService,
    public ls: LocalService, private readonly _ms: MessageService, private _tas: TipoTramiteActividaService,
    private readonly _tt: TipoTramiteService, private _cts: CorreoTemplateService
  ) {
    this.configureTipoTramiteActividadForm();
  }

  ngAfterViewInit(): void {
    this.getCorreoPlantillaDetail();
  }

  ngOnInit(): void {
    this.translate();
    this.getTipoTramiteActividadTipos();
    this.getVariablesRespuestaDinamica();
  }

  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({
      guardar: this._t.get('form.button.guardar'),
      cancelar: this._t.get('form.button.cancelar'),
      noCambiosFormulario: this._t.get('msg.noCambiosFormulario'),
      completeCamposRequeridos: this._t.get('msg.completeCamposRequeridos'),
      exito: this._t.get('common.exito'),
      advertencia: this._t.get('common.advertencia'),
      actividadesGuardadas: this._t.get('msg.actividadesGuardadas'),
      nuevaActividad: this._t.get('msg.nuevaActividad'),
      editarActividad: this._t.get('msg.editarActividad'),
      actividad: this._t.get('common.actividad'),
      orden: this._t.get('common.orden'),
      plazoFechaCierre: this._t.get('common.plazoFechaCierre'),
      automatico: this._t.get('fields.tipo-tramite-actividad.automatico'),
      variablesCorreo: this._t.get('common.variablesCorreo'),
      variablesTramite: this._t.get('common.variablesTramite'),
      noHayValoresValidosConfiguracionLlaves: this._t.get('msg.noHayValoresValidosConfiguracionLlaves')
    }));
  }

  //#region Form

  get formCorreoPlantillaId(): number | undefined {
    return this.form.get('correoPlantillaId')?.value
  }

  set formCorreoPlantillaId(value: number | undefined) {
    this.form.patchValue({ correoPlantillaId: value });
  }

  private configureTipoTramiteActividadForm() {
    this.form = this._fb.group({
      actividadId: [null, [Validators.required]],
      orden: [null, [Validators.required, Validators.min(1)]],
      plazoFechaCierre: [null, [Validators.required, Validators.min(1)]],
      tipoId: [null, [Validators.required]],
      correoPlantillaId: [null]
    });

    this.formSubscriptions();
  }

  private formSubscriptions() {
    this.form.get('tipoId')?.valueChanges.subscribe((value) => {
      if (!value) {
        return;
      }
      const tipo = this.tipoTramiteActividadTipos.find(t => t.id === value);
      this.tipo = tipo?.codificacion ?? '';
      setTimeout(() => {
        if (tipo?.codificacion === "AUTOMATICO") {
          this.form.removeControl('general');
          this.actividadAutomaticaComponent.initialize();
        } else if (tipo?.codificacion === "GENERAL") {
          this.form.removeControl('automatica');
          this.form.get('isAutomatico')?.setValue(false);
        }
      }, 1);

    });

    this.form.get('correoPlantillaId')?.valueChanges.subscribe((value) => {
      this.correoPlantillaIdOnValueChanges(value);
    });
  }

  resetForm() {
    this.form.reset();
  }

  openNewModal(data: ITipoTramiteActividad[]) {
    this.data = data;
    const tipo = this.tipoTramiteActividadTipos.find(t => t.codificacion === "GENERAL");
    this.configureTipoTramiteActividadForm();
    this.form.reset();
    this.formTitle = this.trans.nuevaActividad;
    this.editActividad = undefined;
    this.form.get('tipoId')?.setValue(tipo?.id ?? null);
    this.form.get('orden')?.setValue(this.data.length + 1);
    this.form.get('plazoFechaCierre')?.setValue(1);
    this.getActividades();
    this.displayActividadModal = true;
  }

  openEditModal(data: ITipoTramiteActividad[], actividad: ITipoTramiteActividad) {
    this.data = data;
    const tipo = this.tipoTramiteActividadTipos.find(t => t.id === actividad.tipoId);
    this.configureTipoTramiteActividadForm();
    this.form.reset();
    this.formTitle = this.trans.editarActividad;
    this.editActividad = actividad;
    this.form.get('tipoId')?.setValue(tipo?.id ?? null);
    this.form.get('actividadId')?.setValue(this.editActividad.actividadId);
    this.form.get('orden')?.setValue(this.editActividad.orden);
    this.form.get('plazoFechaCierre')?.setValue(this.editActividad.plazoFechaCierre);
    this.formCorreoPlantillaId = this.editActividad?.respuestaDinamicaPlantillaId ?? undefined;
    this.getActividades();
    this.displayActividadModal = true;
    this.originalValues = { ...this.form.value };
    setTimeout(() => {
      this.tryToInitEditDependencies();
    });
    this.editModalLoaded = true;
  }

  private tryToInitEditDependencies() {
    //Esperar a que carguen todos los componentes antes de iniciar los componentes dependientes
    if (!this.variablesRespDinamicaLoaded || !this.editModalLoaded) {
      return;
    }
    this.correoPlantillaIdIntializeLlaves(this.formCorreoPlantillaId!);
    if(this.editActividad){
      this.correoPlantillaIdLlaves.load(this.editActividad.respuestaDinamicaConfiguracionLlaves ?? []);
      this.configInsercionTablaDinamicaComponent.load(this.editActividad.insercionConfig ?? []);
      this.configActualizacionTablaDinamicaComponent.load(this.editActividad.actualizacionConfig ?? [], this.variablesRespDinamica.filter(v => v.name.startsWith('seguimiento')));
      const correoPlantilla = this.correosTemplate.find(c => c.id === this.formCorreoPlantillaId);
      if(correoPlantilla?.version !== this.editActividad?.respuestaDinamicaPlantillaVersion)
        this.variablesRespDinamicaVersionNotLatest = true;

    }
  }


  onSubmit() {
    if (this.form.invalid) {
      Utils.markAllFormControlsAsTouched(this.form);
      this._ms.add({ severity: 'warn', summary: this.trans.advertencia, detail: this.trans.completeCamposRequeridos });
      return;
    }

    if (this.formCorreoPlantillaId) {
      if (!this.correoPlantillaIdLlaves.isValid()) {
        this._ms.add({ severity: 'warn', summary: this.trans.advertencia, detail: this.trans.noHayValoresValidosConfiguracionLlaves });
        return;
      }
    }

    const tipo = this.tipoTramiteActividadTipos.find(t => t.id === this.form.get('tipoId')?.value);
    const correoPlantilla = this.correosTemplate.find(c => c.id === this.formCorreoPlantillaId);
    let newValues = {
      actividadId: this.form.get('actividadId')?.value,
      orden: this.form.get('orden')?.value,
      opcional: this.form.get('opcional')?.value,
      plazoFechaCierre: this.form.get('plazoFechaCierre')?.value,
      tipoId: this.form.get('tipoId')?.value,
      respuestaDinamicaPlantillaId: correoPlantilla?.id,
      respuestaDinamicaPlantillaVersion: correoPlantilla?.version,
      respuestaDinamicaConfiguracionLlaves: this.correoPlantillaIdLlaves.getValues(),
      insercionConfig: this.configInsercionTablaDinamicaComponent.getComponentValue(),
      actualizacionConfig: this.configActualizacionTablaDinamicaComponent.getComponentValue()
    } as TipoTramiteActividaDto;

    if (tipo?.codificacion === "AUTOMATICO") {
      if (!this.actividadAutomaticaComponent.isValid()) {
        this._ms.add({ severity: 'warn', summary: this.trans.advertencia, detail: this.trans.completeCamposRequeridos });
        return;
      }
      newValues.automatico = this.actividadAutomaticaComponent.getValues();
    } else if (tipo?.codificacion === "GENERAL") {
      newValues.general = this.actividadGeneralComponent.getValues();
    }

    if (this.isNewForm) {
      this.addActividad(newValues);
    } else if (!Utils.isDeepEqual(this.originalValues, newValues)) {
      this.editarActividad(newValues);
    } else {
      this._ms.add({ severity: 'warn', summary: this.trans.advertencia, detail: this.trans.noCambiosFormulario });
    }

    this.onSubmitEvent.emit();
  }
  //#endregion Form

  openLink() {
    window.open(`/#/configuracion/admin-tramites?tabIndex=2`, '_blank');
  }

  private editarActividad(update: TipoTramiteActividaDto) {
    let tipoActividad = this.data.find(t => t.id === this.editActividad?.id);
    if (!tipoActividad) return;

    const actividad = this.actividades.find(a => a.actividadId === update.actividadId);
    if (!actividad) return;

    tipoActividad.actividadId = actividad.actividadId;
    tipoActividad.actividadCodificacion = actividad.actividadCodificacion;
    tipoActividad.tipoId = update.tipoId;
    tipoActividad.orden = update.orden;
    tipoActividad.plazoFechaCierre = update.plazoFechaCierre;
    tipoActividad.tablaDinamicaConfigId = update.automatico?.tablaDinamicaConfigId;
    tipoActividad.llavesConfig = update.automatico?.llavesConfig;
    tipoActividad.reporteLogoId = update.automatico?.reporteLogoId;
    tipoActividad.camposTexto = update.automatico?.camposTexto;
    tipoActividad.columnasVisibles = update.automatico?.columnasVisibles;
    //formulario
    tipoActividad.formularioId = update.general?.formularioId;
    tipoActividad.formularioVersion = update.general?.formularioVersion;
    //correo plantilla
    tipoActividad.respuestaDinamicaPlantillaId = update?.respuestaDinamicaPlantillaId;
    tipoActividad.respuestaDinamicaPlantillaVersion = update?.respuestaDinamicaPlantillaVersion;
    tipoActividad.respuestaDinamicaConfiguracionLlaves = update?.respuestaDinamicaConfiguracionLlaves;
    tipoActividad.insercionConfig = update?.insercionConfig;
    tipoActividad.actualizacionConfig = update?.actualizacionConfig;

    this.displayActividadModal = false;
    this.sortActividades(tipoActividad.id);
  }

  private addActividad(add: TipoTramiteActividaDto) {
    const actividad = this.actividades.find(a => a.actividadId === add.actividadId);
    if (!actividad) return;

    let newTipoActividad = {
      id: this.generateTempId(),
      tipoTramiteId: -1,
      actividadId: actividad.actividadId,
      actividadCodificacion: actividad.actividadCodificacion,
      orden: add.orden,
      plazoFechaCierre: add.plazoFechaCierre,
      tablaDinamicaConfigId: add.automatico?.tablaDinamicaConfigId,
      columnasVisibles: add.automatico?.columnasVisibles,
      llavesConfig: add.automatico?.llavesConfig,
      reporteLogoId: add.automatico?.reporteLogoId,
      camposTexto: add.automatico?.camposTexto,
      tipoId: add.tipoId,
      formularioId: add.general?.formularioId,
      respuestaDinamicaPlantillaId: add?.respuestaDinamicaPlantillaId,
      respuestaDinamicaConfiguracionLlaves: add?.respuestaDinamicaConfiguracionLlaves,
      insercionConfig: add?.insercionConfig,
      actualizacionConfig: add?.actualizacionConfig
    } as ITipoTramiteActividad;

    this.data.push(newTipoActividad);

    this.displayActividadModal = false;
    this.sortActividades(newTipoActividad.id);
  }

  private generateTempId() {
    let tempId = -1;
    do {
      tempId = Math.floor(Math.random() * 10000); // Generate a random number between 0 and 999999
    } while (this.data.some(item => item.id === tempId));
    return tempId;
  }

  private sortActividades(id: number) {
    let ordenIndex = 1;
    this.data.sort((a, b) => a.orden - b.orden);
    let newActividadUpdated: boolean = false;
    let updateActividad = this.data.find(t => t.id === id);
    if (!updateActividad) return;

    for (const actividadExistente of this.data) {

      if (updateActividad.id === actividadExistente.id) {
        continue;
      }

      if (!newActividadUpdated && updateActividad.orden <= ordenIndex) {
        updateActividad.orden = ordenIndex;
        ordenIndex++;
        newActividadUpdated = true;
      }
      actividadExistente.orden = ordenIndex;
      ordenIndex++;
    }
    if (!newActividadUpdated) {
      updateActividad.orden = ordenIndex;
    }
    this.data.sort((a, b) => a.orden - b.orden);
  }

  getActividades() {
    this.actividades = [];
    this._ac.getActividades().subscribe({
      next: (actividades: VwActividad[]) => {
        this.actividades = actividades.filter(a =>
          !this.data.some(t => t.actividadId === a.actividadId) || (this.editActividad && a.actividadId === this.editActividad.actividadId)
        );
      },
      error: (error: HttpErrorResponse) => {
        const parsedError = JSON.parse(error.error)
        this._ms.add({ severity: 'error', summary: parsedError.error, detail: parsedError.message });
      }
    });

  }

  getTipoTramiteActividadTipos() {
    this.ttats.getTipoTramiteActividadTipos().subscribe({
      next: (data: IGetTipoTramiteActividadTipos[]) => {
        this.tipoTramiteActividadTipos = data;
      }
    });
  }

  //#region Respuesta Dinamica
  private getVariablesRespuestaDinamica() {

    let params = {
      formularioId: this.tipoTramite.formularioId,
      formularioVersion: this.tipoTramite.formularioVersion
    } as VariablesRespuestaDinamicaParams;

    if (this.actividadGeneralComponent) {
      const formularioId = this.actividadGeneralComponent.getValues().formularioId;
      const selectedForm = this.actividadGeneralComponent.findFormulario(formularioId) as FormNoData | undefined;
      if (selectedForm) {
        params.formularioSeguimientoId = selectedForm.id
        params.formularioSeguimientoVersion = selectedForm.version
      }
    }
    this._tas.getVariablesRespuestaDinamica(params).subscribe({
      next: (data: IConfiguracionLLaves[]) => {
        this.variablesRespDinamicaLoaded = true;
        this.variablesRespDinamica = data;
        this.correoPlantillaIdIntializeLlaves(this.formCorreoPlantillaId!, false);
        this.tryToInitEditDependencies();
      }
    });
  }

  onActividadGeneralFormularioSelected($event: number) {
    this.getVariablesRespuestaDinamica();
  }

  private getCorreoPlantillaDetail() {
    this._cts.getCorreoPlantillaDetail().subscribe({
      next: data => {
        this.correosTemplate = data;
      }
    });
  }

  oncorreoPlantillaIdClear($event: Event) {
    this.correoPlantillaIdLlaves.reset();
  }

  private correoPlantillaIdIntializeLlaves(value: number, reset: boolean = true) {
    if (!this.correoPlantillaIdLlaves) {
      return;
    }
    if (reset) {
      this.correoPlantillaIdLlaves.reset();
    }
    const selectedTemplate = this.correosTemplate.find(t => t.id === value);
    if (selectedTemplate) {
      const keysData = selectedTemplate.variables?.map(v => ({ name: v, value: v })) || [];
      let keys = {
        data: keysData,
        optionLabel: 'name',
        optionValue: 'value',
        headerText: this.trans.variablesCorreo
      } as LlavesOptions
      let values = {
        data: this.variablesRespDinamica,
        optionLabel: 'name',
        optionValue: 'name',
        headerText: this.trans.variablesTramite
      } as LlavesOptions
      this.correoPlantillaIdLlaves.loadOptions(keys, values);

      if (reset) {
        for (const key of keysData) {
          const newItem = this.correoPlantillaIdLlaves.addNew();
          newItem.name = key.value;
        }
      }
    }
  }

  correoPlantillaIdOnValueChanges(value: number) {
    if (!value) {
      return;
    }
    this.correoPlantillaIdIntializeLlaves(value);
  }
  //#endregion Respuesta Dinamica
}
